import CustomReportStatus from '@/Enums/ReportBuilder/Status.enum';
import { ICustomReport } from '@/Interfaces/ReportBuilder/CustomReport.interface';
import { FileDownloadOutlined } from '@mui/icons-material';
import { Button, buttonClasses } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

interface IProps extends GridRenderCellParams<ICustomReport, number> {
  onDownload: (value?: number) => void;
}

const ActionChip = ({ value, row, onDownload }: IProps) => {
  const handleDownload = useCallback(() => {
    onDownload(value);
  }, [value, onDownload]);

  if (row.status !== CustomReportStatus.Success && row.status !== CustomReportStatus.Partial) return '—';

  return (
    <Button
      startIcon={<FileDownloadOutlined />}
      variant='outlined'
      onClick={handleDownload}
      sx={{
        borderRadius: '32px',
        padding: '4px 12px',
        fontSize: '12px',
        [`& .${buttonClasses.startIcon}`]: {
          marginRight: '4px',
        },
      }}
    >
      Download Report
    </Button>
  );
};

export default ActionChip;
